const importAll = (r) => {
    return r.keys().map(r);
};

export default importAll;
